import { ISystemParamState } from './features/system-params/state/system-params.reducers';
import { IAuthState } from './features/auth/state/auth.reducers';
import { IUserState } from './features/user/state/user.reducers';

export enum EStateStatus {
  PENDING = 'PENDING',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
export const baseActionPrefix = '[MT_AUTH]';
export interface IAppState {
  auth: IAuthState;
  userAdmin: IUserState;
  systemParamsAdmin: ISystemParamState;
}
